import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql, useQuery } = useAppContext();

  const LineItemFragment = gql`
    fragment LineItemFragment on LineItem {
      name
      title
      sku
      variantTitle
      price
      totalDiscount
      vendor
      preProductionStatus
      shopifyRawSku
      requestedDeliveryDate
      accountShipDate
      imageUrl
      returnPolicy
    }
  `;
  const OrderFragment = gql`
fragment OrderFragment on Order {
  clientEmail
  clientName
  createdAt
  confirmed
  currency
  discountCode
  financialStatus
  fullyPaid
  gid
  id
  name
  note
  subTotalPrice
  subtotalLineItemsQuantity
  taxesIncluded
  totalDiscounts
  ecommerceId
  totalPrice
  totalTax
  purchasedElsewhere
  storeName
  lineItems {
    ...LineItemFragment
  }
  bmRecommendation {
      sizeRecommended
      bmRecommendationJson
      receivedAt
  }
  fulfillments {
    trackingNumber
    trackingUrl
  }
}
${LineItemFragment}
`;
  const OrderNodeGql = gql`
  query orderNode($gid: ID!) {
    node(gid: $gid) {
    id
    gid
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;

  const useOrderNodeQuery = (gid) => useQuery(OrderNodeGql, {
    variables: { gid },
    fetchPolicy: 'network-only',
  });

  return {
    OrderFragment,
    useOrderNodeQuery,
  };
};
